<template>
  <div class="check-symptoms">
    <a
      class="btn my-btn d-flex justify-content-between shadow-sm pointer"
      :class="{
        'p-3 svg': size === 'md',
        'px-3 py-2 svg-sm': size === 'sm',
      }"
      @click.prevent="clicked()"
    >
      <small class="uppercase">
        {{ $t("checkyoursymptoms") }}
      </small>
      <SymptomCheckerIcon></SymptomCheckerIcon>
    </a>
    <div class="form shadow" :class="{ visible: show }">
      <div class="p-4">
        <div
          class="close-icon svg shadow-sm rounded-circle pointer"
          @click="show = false"
        >
          <CloseIcon></CloseIcon>
        </div>
        <small class="uppercase d-block pb-2 text-muted">
          {{ $t("gender") }}
        </small>
        <div class="row no-gutters">
          <div class="col m-1">
            <a
              class="border px-3 py-2 pointer svg svg-upper text-nowrap text-center d-inline-block w-100"
              :class="{ 'border-primary shadow-sm': gender === 'male' }"
              @click.prevent="gender = 'male'"
            >
              <MaleIcon></MaleIcon>
              <small class="uppercase">{{ $t("male") }}</small>
            </a>
          </div>
          <div class="col m-1">
            <a
              class="border px-3 py-2 pointer svg svg-upper text-nowrap text-center d-inline-block w-100"
              :class="{ 'border-primary shadow-sm': gender === 'female' }"
              @click.prevent="gender = 'female'"
            >
              <FemaleIcon></FemaleIcon>
              <small class="uppercase">{{ $t("female") }}</small>
            </a>
          </div>
        </div>
        <label class="m-1 mt-3 w-100">
          <small class="uppercase d-block pb-2 text-muted">{{
            $t("age")
          }}</small>
          <input
            type="number"
            v-model="age"
            class="p-2 text-center age w-100"
          />
        </label>
        <a
          class="m-1 d-block text-center w-100 mt-4 border border-primary p-2 pointer"
          @click.prevent="startInterview()"
        >
          {{ $t("startInterview") }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MaleIcon from '@/components/Icons/Male'
import FemaleIcon from '@/components/Icons/Female'
import CloseIcon from '@/components/Icons/Close'
import SymptomCheckerIcon from '@/components/Icons/SymptomChecker'
export default {
  components: {
    MaleIcon,
    FemaleIcon,
    CloseIcon,
    SymptomCheckerIcon
  },
  props: {
    size: {
      type: String,
      default: 'md'
    }
  },
  data () {
    return {
      show: false,
      age: null,
      gender: null
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/user',
      authLocale: 'auth/locale'
    })
  },
  methods: {
    ...mapActions({
      interviewInit: 'interview/init'
    }),
    clicked () {
      if (this.authUser) {
        this.startInterview()
      } else {
        this.show = !this.show
      }
    },
    async startInterview (type) {
      if (!this.authUser) {
        if (!this.age || !this.gender) {
          this.showPopup = true
          return
        } else {
          this.$cookie.set('age', parseInt(this.age), 60 * 15)
          this.$cookie.set('gender', this.gender, 60 * 15)
        }
      }
      const id = await this.interviewInit({
        age: this.age,
        gender: this.gender,
        type: 'SymptomChecker',
        locale: this.$i18n.locale
      })
      if (id) {
        this.$router.push({ path: `interview/${id}` })
      }

      // let url = '/guest/interviews'
      // if (this.authUser) {
      //   url = '/api/interviews'
      // } else if (!this.age || !this.gender) {
      //   this.showPopup = true
      //   return
      // }
      // try {
      //   const params = {
      //     type: type,
      //     language: 'ka'
      //   }
      //   if (this.age && this.gender) {
      //     params.age = parseInt(this.age)
      //     params.gender = this.gender
      //     this.$cookie.set('age', parseInt(this.age), 60 * 15)
      //     this.$cookie.set('gender', this.gender, 60 * 15)
      //   }
      //   if (this.authUser) {
      //     params.patient_id = this.authUser.id
      //   }
      //   params.language = this.$i18n.locale
      //   const response = await this.axios.post(url, params)
      //   this.$router.push({ path: `interview/${response.data.data.id}` })
      // } catch (err) {
      //   this.setAlert({
      //     message: err,
      //     type: 'danger'
      //   })
      // }
    }
  }
}
</script>
<style lang="scss">
.check-symptoms {
  .close-icon {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .form {
    position: absolute;
    background-color: white;
    height: 0px;
    position: relative;
    overflow: hidden;
    transition: all 0.2s ease-in;
    border-radius: 0px 5px 5px 0px;
    &.visible {
      height: 345px;
    }
  }
}
</style>
<i18n>
{
  "ka": {
    "checkyoursymptoms": "გადაამოწმე სიმპტომები AI-ს დახმარებით",
    "startInterview": "კითხვარის დაწყება",
    "male": "მამრობითი",
    "female": "მდედრობითი",
    "age": "ასაკი",
    "gender": "სქესი"
  },
  "en": {
    "checkyoursymptoms": "Check your symptoms using AI",
    "startInterview": "Start Symptom Checker",
    "male": "Male",
    "female": "Female",
    "age": "Age",
    "gender": "Gender"
  }
}
</i18n>
